// extracted by mini-css-extract-plugin
export var archiveLink = "ListPostsModule-module--archiveLink--hUup8";
export var archiveLinkIcon = "ListPostsModule-module--archiveLinkIcon--XlRIh";
export var broadcast = "ListPostsModule-module--broadcast--QZOib";
export var component = "ListPostsModule-module--component--6XQFF";
export var footer = "ListPostsModule-module--footer--MXlFS";
export var hasMoreItems = "ListPostsModule-module--hasMoreItems--lP2dl";
export var list = "ListPostsModule-module--list--rbEAj";
export var toggler = "ListPostsModule-module--toggler--RapQJ";
export var togglerIcon = "ListPostsModule-module--togglerIcon--Zqo2i";